import { Component, ReactNode } from "react";
import { toAbsoluteUrl } from "_metronic/helpers";
import { disableSplashScreen } from "_metronic/layout/core/LayoutProvider";
import getAbsoluteLogoURL from "global/helpers";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch() {
    // The app may crash before it hides the loading splash
    disableSplashScreen();
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="d-flex flex-column flex-root min-vh-100">
        <div
          className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
          style={{
            backgroundImage: `url('${toAbsoluteUrl("/media/illustrations/progress-hd.png")}')`,
          }}
        >
          <div className="d-flex flex-column flex-column-fluid justify-content-center align-items-center text-center p-10">
            <a href="/" className="mb-10" data-test-id="app-error-boundary__logo-link">
              <img alt="Logo" src={getAbsoluteLogoURL()} className="proptimo-logo-large mb-15 mx-auto" />
            </a>
            <div>
              <h1 className="fw-bolder fs-4x text-gray-700 mb-10">This page couldn't be loaded</h1>
              <button
                type="button"
                className="btn btn-lg btn-primary"
                data-test-id="app-error-boundary__reload-button"
                onClick={() => window.location.reload()}
              >
                Reload
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { AppErrorBoundary };
